import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalizationSettingsKeys } from '@core/enums/globalization-settings-keys.enum';
import { environment } from '@environments/environment';
import { appCodes } from '@core/constants/app-codes.constant';
import { lastValueFrom } from 'rxjs';
import { ApplicationConfiguration } from 'src/app/camms-risk/models/application-configuration/application-configuration';
import { ApplicationTimeZone } from 'src/app/camms-risk/models/region-settings/application-time-zone';
import { GlobalizationSetting } from 'src/app/camms-risk/models/region-settings/globalization-setting';
import { ApiBaseService } from './api-base.service';

@Injectable({
    providedIn: 'root',
})
export class AppconfigService {
    public urlConfigs: any | null;
    public appsettings: any;
    public adjustmentRule: any[];
    private applicationTimeZone: ApplicationTimeZone[] = [];
    private globalizationSettings?: GlobalizationSetting;

    public accessTokenExpirationMinutes: number = 0;
    public sessionTimeoutWarningInMin: number = 0;
    public sessionTimeoutInMin: number = 0;

    constructor(
        private httpClient: HttpClient,
        private apiBaseService: ApiBaseService,
    ) { }

    public async LoadConfig(): Promise<void> {
        if (environment.production) {
            try {
                this.urlConfigs = await lastValueFrom(
                    this.httpClient.get(
                        `./assets/url/api-endpoint/api-endpoint.json?v=${new Date().getUTCMilliseconds()}`,
                    ),
                );

                (environment.defaultApiVersion =
                    this.urlConfigs.project.defaultApiVersion),
                    (environment.baseUrl = this.urlConfigs.project.baseUrl),
                    (environment.commonDefaultApiVersion =
                        this.urlConfigs.common.defaultApiVersion),
                    (environment.commonBaseUrl =
                        this.urlConfigs.common.baseUrl),
                    (environment.ipm_URL = this.urlConfigs.LegacyApp.IPM_URL),
                    (environment.irm_url = this.urlConfigs.IRM.IRMBaseUrl);
                environment.imsURL = this.urlConfigs.IMS.IMSBaseUrl;
                environment.cmsURL = this.urlConfigs.CMS.CMSBaseUrl;
                environment.commonControlApiBaseUrl =
                    this.urlConfigs.CommonControls.CommonControlApiUrl;
                environment.commonControlAppUrl =
                    this.urlConfigs.CommonControls.CommonControlAppUrl;
                environment.surveyAPIUrl = this.urlConfigs.Survey.SurveyAPIUrl;
                environment.surveyAppUrl = this.urlConfigs.Survey.SurveyAppUrl;
                environment.interplanURL = this.urlConfigs.LegacyAppIP.IP_URL;
                environment.commonLoginPortalUrl = this.urlConfigs.common.URL_COMMON_LOGIN_PORTAL;                

                environment.commonActionApi = this.urlConfigs.CommonAction.ActionApiUrl;
                environment.commonActionAppUrl = this.urlConfigs.CommonAction.ActionAppUrl;
                environment.cammsServiceApiUrl = this.urlConfigs.Service.ApiUrl;
                environment.cammsServiceClientUrl = this.urlConfigs.Service.AppUrl;
                environment.dsmBaseUrl = this.urlConfigs.Dsm.DsmBaseUrl;
                environment.administrationAppUrl =
                    this.urlConfigs.Administration.AdministrationAppUrl;
                environment.legacyApiUrl = this.urlConfigs.LegacyApiUrl;    
                environment.bowTieAppUrl = this.urlConfigs.Bowtie.AppUrl;
                    

                console.log("ActionApiUrl: ", this.urlConfigs.CommonAction.ActionApiUrl);
                console.log("ActionAppUrl: ", this.urlConfigs.CommonAction.ActionAppUrl);

                localStorage.setItem(
                    appCodes.auth.actionApiUrl,
                    this.urlConfigs.CommonAction.ActionApiUrl,
                );

                localStorage.setItem(
                    appCodes.auth.actionAppUrl,
                    this.urlConfigs.CommonAction.ActionAppUrl,
                );

                localStorage.setItem(
                    appCodes.auth.riskApiUrl,
                    this.urlConfigs.project.baseUrl,
                );

                localStorage.setItem(
                    appCodes.auth.IMS_Url,
                    this.urlConfigs.IMS.IMSBaseUrl,
                );

                environment.CammsIncidentServiceApiUrl = this.urlConfigs.CammsIncident.IncidentServiceApiUrl;
                environment.CammsIncidentClientUrl = this.urlConfigs.CammsIncident.IncidentClientUrl;
                localStorage.setItem(
                    appCodes.auth.CammsIncidentServiceApiUrl,
                    this.urlConfigs.CammsIncident.IncidentServiceApiUrl
                );

                localStorage.setItem(
                    appCodes.auth.CammsIncidentClientUrl,
                    this.urlConfigs.CammsIncident.IncidentClientUrl
                );

                localStorage.setItem(
                    appCodes.auth.commonControlApiUrl,
                    this.urlConfigs.CommonControls.CommonControlApiUrl,
                );

                localStorage.setItem(
                    appCodes.auth.commonControlAppUrl,
                    this.urlConfigs.CommonControls.CommonControlAppUrl,
                );
                localStorage.setItem(
                    appCodes.auth.surveyAPIUrl,
                    this.urlConfigs.Survey.SurveyAPIUrl,
                );

                localStorage.setItem(
                    appCodes.auth.surveyAppUrl,
                    this.urlConfigs.Survey.SurveyAppUrl,
                );

                localStorage.setItem(
                    appCodes.auth.cammsServiceClientUrl,
                    this.urlConfigs.Service.AppUrl,
                );

                localStorage.setItem(
                    appCodes.auth.cammsServiceApiUrl,
                    this.urlConfigs.Service.ApiUrl,
                );

                let appSettings: any = await lastValueFrom(
                    this.getAppSettingsFromAssets(),
                );

                this.appsettings = appSettings;

                environment.isCommonLoginEnabled = appSettings?.isCommonLoginEnabled ?? false;
                environment.isOneTimeTokenEnabled = appSettings?.isOneTimeTokenEnabled ?? true;
            } catch (e) {
                throw e;
            }
        } else {
            localStorage.setItem(
                appCodes.auth.CammsIncidentServiceApiUrl,
                environment.CammsIncidentServiceApiUrl
            );

            localStorage.setItem(
                appCodes.auth.CammsIncidentClientUrl,
                environment.CammsIncidentClientUrl
            );
            localStorage.setItem(
                appCodes.auth.riskApiUrl,
                environment.baseUrl,
            );
            localStorage.setItem(
                appCodes.auth.cammsServiceClientUrl,
                environment.cammsServiceClientUrl,
            );

            localStorage.setItem(
                appCodes.auth.cammsServiceApiUrl,
                environment.cammsServiceApiUrl,
            );

            let appSettings: any = await lastValueFrom(
                    this.getAppSettingsFromAssets(),
            );

            this.appsettings = appSettings;
            
            environment.isOneTimeTokenEnabled = appSettings?.isOneTimeTokenEnabled;
            
        }
    }

    public getApplicationConfiguration() {
        return this.apiBaseService.get<ApplicationConfiguration>(
            [`ApplicationConfiguration/GetApplicationConfiguration`],
            {},
        );
    }

    getAppSettingsFromAssets() {
        return this.httpClient.get(`assets/settings/app-settings.json?v=${new Date().getUTCMilliseconds()}`);
    }

    public getUserGlobalizationSettings() {
        return this.apiBaseService
            .get<GlobalizationSetting[]>(['RegionSettings/user'])
            .subscribe((globalizationSettings) => {
                this.globalizationSettings = globalizationSettings?.find(
                    (o) => o.settingName === GlobalizationSettingsKeys.TimeZone,
                );
                this.setAdjustmentRules();
            });
    }

    public setAdjustmentRules() {
        this.apiBaseService
            .get<
                ApplicationTimeZone[]
            >(['RegionSettings/GetSystemTimeZones'], { isLoading: true })
            .subscribe((res) => {
                this.applicationTimeZone = res;
                let adjustmentRule = this.applicationTimeZone?.find(
                    (x) =>
                        x.displayName ==
                        this.globalizationSettings?.settingValue,
                )?.adjustmentRule;
                this.adjustmentRule = adjustmentRule ?? [];
            });
    }

    public getAdjustmentRule() {
        return this.adjustmentRule;
    }
}
